module.exports = __webpack_public_path__ + "static/media/RoyPlus live.d9b3828d.jpg";